import { LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import Flex, { FlexProps } from "./Flex";
import { inputLabel } from "./MaskInput";
import Text from "./Text";

type CustomTimePickerProps = {
  minTime?: Dayjs;
  maxTime?: Dayjs;
  onChange?: (val: dayjs.Dayjs | null) => void;
  label?: string;
  value?: any;
  flexProps?: FlexProps;
  error?: string | boolean;
  required?: boolean;
  marginBottom?: string;
  slots?: any;
  slotProps?: any;
  placeholder?: string;
  name?: string;
  handleBlur?: any;
  disabled?: boolean;
  valueFormatter?: "hh:mm A";
  disableError?: boolean;
};

const CustomTimePicker = (props: CustomTimePickerProps) => {
  return (
    <Flex
      {...props.flexProps}
      flexDirection={props.flexProps?.flexDirection ?? "column"}
      width={"100%"}
    >
      {/* <Typography mb={props.marginBottom ?? "10px"} sx={DEFAULT_FONTSIZE}>
        {props.label}
        {props.required && (
          <Typography fontSize={"13px"} component={"span"} color={"error"}>
            {` *`}
          </Typography>
        )}
      </Typography> */}
      <Flex flexDirection={"column"} width={"100%"}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <TimePicker
            disabled={!!props?.disabled}
            slots={{ ...(props.slots ?? {}) }}
            slotProps={{
              inputAdornment: {
                position: props.slotProps?.inputAdornment?.position || "start",
              },
              ...(props.slotProps ?? {}),
              textField: {
                label: inputLabel(props?.label, props?.required),
                onBlur: props.handleBlur,
                name: props.name,
                placeholder: props.placeholder ?? "hh:mm:aa",
                error: !!props.error,
              },
            }}
            label={inputLabel(props?.label, props?.required)}
            minTime={props?.minTime}
            maxTime={props?.maxTime}
            sx={{
              "& .MuiInputAdornment-positionStart": {
                marginRight: "0px !important",
              },
              "& .MuiIconButton-root": {
                paddingRight: "0px !important",
              },
              "& .MuiIconButton-root .MuiSvgIcon-root": {
                fontSize: "10px !important",
              },
            }}
            // sx={{
            //   width: "100%",
            //   "& .MuiOutlinedInput-root": {
            //     border: props?.error ? "0.0001rem solid red" : undefined,
            //     borderColor: props.error ? "error.main" : undefined,
            //     "& fieldset": {
            //       borderColor: props.error ? "error.main" : undefined,
            //     },
            //     "&:hover fieldset": {
            //       borderColor: props.error ? "error.main" : "inherit",
            //     },
            //     "&.Mui-focused fieldset": {
            //       borderColor: props.error ? "error.main" : "primary.main",
            //     },
            //   },
            // }}
            value={
              props.value ? dayjs(props.value, props.valueFormatter) : null
            }
            onChange={(val) => {
              props.onChange?.(val);
            }}
          />
        </LocalizationProvider>

        {!!props.error && !props.disableError && (
          <Text fontSize={"13px"} variant="caption" color="error">
            {props.error}
          </Text>
        )}
      </Flex>
    </Flex>
  );
};

export default CustomTimePicker;
